import { v1 as uuidv1 } from 'uuid';

/**
 * Amp Analytics
 * @category Functional Component
 * @summary Handles AMP analytics.
 * @prop {Object} data - The analytics data.
 * @return {Node} React node containing the analytics components.
 */

const AmpAnalytics = props => {
  const { data } = props;

  // Define Amp Specific or Utag Derived Data
  const typeData = {};
  switch(data.__typename) {
    case 'video':
      typeData.pageType = 'video_amp'
      typeData.siteSection = 'videos'
      typeData.type = 'video';
      break;
    case 'article':
      typeData.pageType = 'article_amp';
      typeData.siteSection = data?.field_category?.name;
      typeData.type = 'article';
      break;
    default:
      typeData.pageType = '';
      typeData.siteSection = '';
      typeData.type = '';
  }

  return (
    <>
      <amp-analytics type="comscore">
        <script type="application/json" dangerouslySetInnerHTML={{ __html: `
          {
            "vars": {
              "c2": "3005086"
            },
            "extraUrlParams": {
              "comscorekw": "amp"
            }
          }
        `}} />
      </amp-analytics>
      <amp-analytics>
        <script type="application/json" dangerouslySetInnerHTML={{ __html: `
          {
            "transport": {
              "xhrpost": false,
              "beacon": true
            },
            "requests": {
              "host": "https://saa.thedrewbarrymoreshow.com/b/ss/\${siteAccount}/1/G.5--NS/sRANDOM?AQB=1&vid=CLIENT_ID(AMP_ECID_GOOGLE,,_ga)&ns=cbsinteractive&ndh=0&ce=\${documentCharset}&pageName=\${canonicalPath}&g=\${canonicalUrl}&r=\${documentReferrer}&bh=\${availableScreenHeight}&bw=\${availableScreenWidth}&c=\${screenColorDepth}&j=amp&s=\${screenWidth}x\${screenHeight}&server=\${ampdocHost}&c9=D=User-Agent&c.&brandPlatformId=\${ampPage}&browserTitle=\${title}&pageViewGuid=CLIENT_ID(AMP_ECID_GOOGLE,,_ga)|\${pageViewId}&pageType=\${pageType}&sitePrimaryRsid=\${siteAccount}&siteType=\${siteType}&siteHier=\${sitehier}&siteSection=\${siteSection}&pageTitle=\${title}&pageUrl=\${canonicalUrl}&userType=anon&userRegId=not%20authenticated&siteCode=drewbarrymore&assetType=\${type}&deviceType=\${deviceType}&editorialContentId=\${guid}&editorialContentName=\${title}",
              "pageview": "\${host}&.c&AQE=1",
              "event19": "\${host}&events=event19&v46=\${v46}&pe=lnk_o&AQE=1",
              "ecomLink": "\${host}&events=event19,event35&v46=\${linkRegion}|\${linkSubRegion}|\${linkFormat}|\${leadStore}|\${linkCta}&v63=\${destinationUrl}&v66=\${leadStore}&v102=\${linkCta}&v103=\${linkFormat}&v105=D=v46&e=lnk_o&pev2=ampclickLead&AQE=1"
            },
            "vars": {
              "siteAccount": "${ process.env.NEXT_PUBLIC_SITE_PRIMARY_RSID }",
              "siteType": "google_amp",
              "ampPage": "drewbarrymore_site_amp",
              "guid": "${ uuidv1() }",
              "pageType": "${ escape(typeData.pageType) }",
              "siteSection": "${ escape(typeData.siteSection) }",
              "sitehier": "${ escape(typeData.siteSection) }|amp",
              "title": "${ escape(data.title) }",
              "type": "${ escape(typeData.type) }",
              "deviceType": "mobile"
            },
            "triggers": {
              "pageTimer": {
                "on": "timer",
                "timerSpec": {
                  "interval": 1,
                  "maxTimerLength": 0.99,
                  "immediate": false
                },
                "request": "pageview"
              }
            }
          }
        `}} />
      </amp-analytics>
      <amp-analytics type="chartbeat">
        <script type="application/json" dangerouslySetInnerHTML={{ __html: `
          {
            "vars": {
              "uid": "20200",
              "domain": "thedrewbarrymoreshow.com",
              "sections": "${ escape(typeData.siteSection) }",
              "author": "${ escape(data.field_byline_text) }"
            }
          }
        `}} />
      </amp-analytics>
    </>
  );
}

export default AmpAnalytics;
